<template>
  <div class="items-list">

    <b-card>
      <!-- s -->
      <div class="float-right " style="width:300px;">
        <multiselect
          v-model="department"
          :options="departments"
          :multiple="false"
          track-by="id"
          :show-labels="false"
          :allow-empty="true"
          label="name"
          :placeholder="$t('promo-to-product.department')"
          class="multiselect-pricing"
        >
        </multiselect>
      </div>
      <b-table
        id="my-table"
        :items="itemsForBarcode"
        :fields="fields"
        small show-empty
      >
      <template slot="empty" slot-scope="scope">
        <h4 class="text-center">{{ $t('empty') }}</h4>
      </template>
      <template slot="index" slot-scope="data">
        <!--								{{ data.index + 1 }}-->
      <strong>  {{ paginate(data.index, searchForBarcode.page, searchForBarcode.limit) }}</strong>
      </template>
      <template slot="id" slot-scope="data">
        <vs-checkbox type="checkbox"
              :id="data.item.itemId"
               :vs-value="data.item"
               v-model="checkedItems"/>
      </template>
      <template slot="artikul" slot-scope="data">
          <div v-for="(tmp,index) in data.item.vendorCodes" :key="`qwe-${index}`">
                  {{ tmp.vendor }}
          </div>
      </template>
      <template slot="itemPriceUzs" slot-scope="data">
        {{data.item.itemPriceUzs | currency({symbol: department.currencyName, fractionCount: 2, symbolPosition: 'back',thousandsSeparator: '' })}}
      </template>
      <template slot="discount"  slot-scope="data">
       <span v-if="data.item.promoType == '%'">{{data.item.discount}}{{data.item.promoType}}</span>
       <span v-else>{{data.item.discount | currency({symbol: department.currencyName, fractionCount: 2, symbolPosition: 'back',thousandsSeparator: '' })}}</span>
      </template>
      <template slot="discountPrice" slot-scope="data">
        {{data.item.discountPriceUzs | currency({symbol: department.currencyName, fractionCount: 2, symbolPosition: 'back',thousandsSeparator: '' })}}
      </template>

       <template slot="count" slot-scope="data">
           <b-col>
             <b-input-group size="sm">
               <b-form-input v-model="data.item.count"
               size="sm" autocomplete="off" type="number"
               :disabled="!checkedItems.includes(data.item)"
               ></b-form-input>
             </b-input-group>
           </b-col>
       </template>
      </b-table>
      <nav>
        <b-pagination :total-rows="totalForBarcode" :per-page="searchForBarcode.limit"
                v-model="searchForBarcode.page"
                :prev-text="$t('pagination.prev')"
                :next-text="$t('pagination.next')"
                 hide-goto-end-buttons/>
      </nav>
      <div  style="display: flex;justify-content: flex-end">
  			<b-button @click="closeModal" style="margin-right: 10px;"
        variant="primary" size="sm">{{$t('cancel')}}
  			</b-button>
  			<b-button size="sm" variant="success"
        :disabled="checkedItems.length <= 0 || !itemsForBarcode"
         @click="createBarcode(department.currencyName)">{{$t('save')}}</b-button>
  		</div>
    </b-card>
  </div>
</template>

<script>
import PromoService from "../../../../services/promo.service";
import {mapActions, mapState} from 'vuex';
import Multiselect from 'vue-multiselect'

export default {
  components: {Multiselect},
  data() {
    return {
      department: null,
      searchForBarcode: {
        page: 1,
        limit: 20,
        attributes: []
      },
      isCheckAll: false,
      fields: [
        {
          key: 'id',
          label: '',
          class: ['middle']

        },
        {
          key: 'index',
          label: '#',
          class: ['text-center', 'p-2', 'middle']

        },
        {
          key: 'itemName',
          label: this.$t('goods.name'),
          class: ['text-center', 'middle']
        },
        {
          key: 'itemBarcode',
          label:  this.$t('goods.barcode'),
          class: ['text-center', 'middle']
        },
        {
          key: 'itemPriceUzs',
          label: this.$t('promo-to-product.initial-price'),
          class: ['text-center', 'middle']
        },
        {
          key: 'discountPrice',
          label: this.$t('promo-to-product.discount-price'),
          class: ['text-center', 'middle']
        },
        {
          key: 'discount',
          label:   this.$t('promo-to-product.discount'),
          class: ['text-center', 'middle']
        },
        {
          key: 'count',
          label:  this.$t('pos.qty'),
          class: ['text-center', 'widthTh', 'middle']
        }],
      // searchForm: {
      //   page: 1,
      //   limit: 20
      // },
      checkedItems: []
    }
  },
  computed:{
    ...mapState('promo', [ 'departments', 'promoId',
      'itemsForBarcode', 'totalForBarcode', 'discount', 'promoType'
    ]),
    ...mapState(['userDepCurrencyName']),
  },
  methods: {

    ...mapActions('promo', [
      'setCurrentItems'
    ]),
    paginate(index, page_size, page_number) {
      --page_size;
      return (page_number * page_size) + index + 1;
    },
    async createBarcode(cr) {
      await this.checkedItems.forEach(el => {
        el.currencyName = cr
      })
      await this.setCurrentItems(this.checkedItems);
      await this.$router.push(`/point-of-sale/sale/barcodes`);
    },
    async closeModal() {
      await this.$store.commit('promo/setItemsForBarcode', null)
      await this.$store.commit('promo/setTotalForBarcode', 0)
      this.department = null
      this.checkedItems = [];
      this.isCheckAll = false;
      this.$emit('closeModal', false);
    },
    checkAll(items) {
      this.isCheckAll = !this.isCheckAll;
      this.checkedItems = [];
      if (this.isCheckAll) { // Check all
        for (let i = 0; i < items.length; i++) {
          this.checkedItems.push(items[i])
        }
      }
    }
  },
  watch: {
    'department': {
      async handler(newVal) {
        if(newVal) {
           let payload = {
            promotionId: this.promoId,
            page: 1,
            depId: newVal.id,
            limit: this.searchForBarcode.limit
          }
          this.isCheckAll = false;
          this.checkedItems = [];
          await PromoService.getPromotionForBarcode(payload).then(response => {
          	response.data.promoItems.forEach(el => {
          		el.discount = this.discount
          		el.promoType = this.promoType
          		 if(this.promoType == '%') {
                  	let promoSumma = this.discount/100*el.itemPriceUzs
                     el.discountPriceUzs = el.itemPriceUzs - promoSumma
                 }else {
                 	el.discountPriceUzs = el.itemPriceUzs - el.discount
                 }
          	})
            this.$store.commit('promo/setItemsForBarcode', response.data.promoItems)
            this.$store.commit('promo/setTotalForBarcode', response.data.totalItems)
          });
        }else{
          this.isCheckAll = false;
          this.checkedItems = [];
          await this.$store.commit('promo/setItemsForBarcode', null)
          await this.$store.commit('promo/setTotalForBarcode', 0)

        }
      }
    },
    'searchForBarcode.page' : {
      async handler(newVal) {
        let payload = {
          promotionId: this.promoId,
          page: newVal,
          depId: this.department.id,
          limit: this.searchForBarcode.limit
        }
        await PromoService.getPromotionForBarcode(payload).then(response => {
			response.data.promoItems.forEach(el => {
				el.discount = this.discount
				el.promoType = this.promoType
				if(this.promoType == '%') {
					let promoSumma = this.discount/100*el.itemPriceUzs
					el.discountPriceUzs = el.itemPriceUzs - promoSumma
				}else {
					el.discountPriceUzs = el.itemPriceUzs - el.discount
				}
			})
          this.$store.commit('promo/setItemsForBarcode', response.data.promoItems)
          this.$store.commit('promo/setTotalForBarcode', response.data.totalItems)
        });
        await this.$store.commit('promo/setPromotion', payload);
      }
    },
    'checkedItems': {
      handler(newValue, oldValue) {
        if (newValue.length !== oldValue.length) {
          this.isCheckAll = false;
        }
        if(this.itemsForBarcode) {
          if (this.itemsForBarcode.length == newValue.length) {
            this.isCheckAll = true;
          }
        }
      }
    }
  }
}
</script>

<style lang="css">
  .widthTh {
    width: 20%;
  }
  .middle {
    vertical-align: middle !important;
  }
</style>
